$(function () {
    function realignMenu() {
        var headerOffset = $(".header-container").offset().left;
        var navOffset = $(".megamenu-navigation").offset().left;
        $(".navigation-item").each(function () {
            var offset = $(this).offset().left;
            offset = Math.round(offset);
            $(this).find('.dropdown-menu__container').css('left', (-1 * (navOffset)) + 'px');
            //$(this).find('.menu-info-container').css('padding-left', (offset - 490 + 20) + 'px');

            var segment = $(this).attr('segment');
            if(segment){
                if($(".segment-" + segment ).length){
                    var distance = offset - headerOffset - 305;
                    $(".segment-" + segment ).css('margin-left', distance + 'px');

                    //var menuContainerOffset = $(".segment-" + segment ).offset().left;
                }
            }
        });
     }

    window.onresize = function () {
        realignMenu();
    };

    if($(".header-container").length){
        realignMenu();
    }


    function toggleSearchDialog() {
        $(".search-dialog").toggle();
        $('.main-container').toggle();
        $('.main-footer').toggle();
        $('.back-to-top').toggle();
    }

    $(".search-box-btn").click(function () {
        toggleSearchDialog();
    });
    $(".search-dialog-btn-close").click(function () {
        toggleSearchDialog();
    });

    /*$('.second-menu-item-btn').click(function (e) {
        if (!$(event.target).hasClass('submenu-item--link')) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            } else {
                $('.second-menu-item-btn').removeClass('active');
                $(this).addClass('active');
            }
        }
    });*/

    $(document).click(function (event) {
        if (!$(event.target).hasClass('menu-item--link') && !$(event.target).hasClass('submenu-item--link')) {
            $('.second-menu-item-btn').removeClass('active');
        }
    });

  /*  $(document).on('click', '.custom-radio, .custom-checkbox', function () {
        $(this).prev().click();
    });*/

    if($('.page--submenu').length){
        if($('.sticky-sub-menu-container').length){
            var height = $('.sticky-sub-menu-container').height() ;
            var minHeight = height + 450;
            $("main.main-container").css('min-height', minHeight + 'px');
        }
    }


    if($('#timeline').length){

        var visibleItems = 3;
        if($(window).width() <= 768){
            visibleItems = 2;
        }
        if($(window).width() <= 500){
            visibleItems = 1;
        }
        timeline($('#timeline'), {
            forceVerticalMode: 10,
            mode: 'horizontal',
            verticalStartPosition: 'left',
            visibleItems: visibleItems
        });

        if ($(".timeline__items").length) {
            $(".timeline__items").draggable({
                axis: "x"
            });
        }

        $(".timeline-nav-button--next").html('<span class="grand-icon icon-arrow"></span>');
        $(".timeline-nav-button--prev").html('<span class="grand-icon icon-left-arrow"></span>');
    }


    if ($(".nav-tabs-model").length) {

        let elem = $(".nav-tabs-model > li > a");
        elem.click(function () {
            elem.each(function () {
                $(this).removeClass("active");
            });

            $(this).addClass("active");
        });

        autoHighlightMenu();

    }

    function autoHighlightMenu() {
        // Cache selectors
        var lastId,
            topMenu = $(".nav-tabs-model"),
            topMenuHeight = topMenu.outerHeight() + 1,
            // All list items
            menuItems = topMenu.find("a"),
            // Anchors corresponding to menu items
            scrollItems = menuItems.map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });

// Bind click handler to menu items
// so we can get a fancy scroll animation
        menuItems.click(function (e) {
            var href = $(this).attr("href"),
                offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
            $('html, body').stop().animate({
                scrollTop: offsetTop - 200
            }, 200);
            e.preventDefault();
        });

// Bind to scroll
        $(window).scroll(function () {

            var fromTop = $(this).scrollTop() + topMenuHeight;

            // Get id of current scroll item
            var cur = scrollItems.map(function () {
                if ($(this).offset().top < fromTop + 200) {
                    return this;
                }

            });

            // Get the id of the current element
            cur = cur[cur.length - 1];
            var id = cur && cur.length ? cur[0].id : "";

            if (lastId !== id) {

                lastId = id;

                menuItems.removeClass("active");

                menuItems.each(function () {
                   if($(this)[0].hash === ("#"+id)) {
                       $(this).addClass("active");
                   }
                });
                if($(".nav-tabs-model a.active").length == 0){
                   $('.nav-tabs-model a').first().addClass('active');
                }
            }
        });
    }

    $(".non-clickable > a").click(function(e){
        e.preventDefault();
    });

    $('.filter-container .number-input').each(function(){
        $(this).wrap('<span class="number-input-wrapper" />');
        $(this).before('<span class="number-input-btn minus-btn"><span class="grand-icon icon-minus"></span></span>');
        $(this).after('<span class="number-input-btn plus-btn"><span class="grand-icon icon-plus"></span></span>');
    });

    $(document).on('click', '.plus-btn', function () {
        var value = $(this).prev().val();
        value = parseInt(value);

        $(this).prev().val(value + 1).change();

    });

    $(document).on('click', '.minus-btn', function () {
        var value = $(this).next().val();
        value = parseInt(value);
        var min = $(this).next().attr("min");
        if(min || min == '0'){
            min = parseInt(min);
            if(value - 1 < min){
                return;
            }
        }
        $(this).next().val(value - 1).change();
    });

    function saveProfile(key, value) {
        if(value){
            $.post('/cache/saveProfile', {
                'key': key,
                'value': value
            });
        }
    }

    if(typeof tradeUser !== 'undefined' ){
        $('.profile--first-name').val(tradeUser.firstName);
        $('.profile--last-name').val(tradeUser.lastName);
        $('.profile--business-name').val(tradeUser.businessName);
        $('.profile--email').val(tradeUser.email);
        $('.profile--phone').val(tradeUser.phone);

        $(document).on('change', 'input.profile--first-name', function () {
            saveProfile('CachedFirstName', $(this).val());
        });

        $(document).on('change', 'input.profile--last-name', function () {
            saveProfile('CachedLastName', $(this).val());
        });

        $(document).on('change', 'input.profile--business-name', function () {
            saveProfile('CachedBusinessName', $(this).val());
        });

        $(document).on('change', 'input.profile--email ', function () {
            saveProfile('CachedEmail', $(this).val());
        });

        $(document).on('change', 'input.profile--phone ', function () {
            saveProfile('CachedPhone', $(this).val());
        });
    }

    $('.close-alert-btn').click(function () {
        var curTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem('close-notice-time', curTime);
        console.log(localStorage.getItem('close-notice-time'));
        $('.alert-banner').slideUp();
    });


    if(!localStorage.getItem('close-cookie-notice')){
        $('.cookie-banner').addClass('active');
    }

    $('.close-cookie-banner').click(function(){
        localStorage.setItem('close-cookie-notice', 1);
        $('.cookie-banner').removeClass('active');
    });

    if(localStorage.getItem('close-notice-time')){
        var expireTime = parseInt(localStorage.getItem('close-notice-time'));
        var curTime = new Date().getTime();
        if( curTime > expireTime ){
            $('.alert-banner').show();
        }
    }else{
        $('.alert-banner').show();
    }

    $('input.datepicker-input').attr('readonly', true);

    $('.survey-floating__trigger').click(function () {
        $(this).parent().toggleClass('active');
    });

    $('.survey-floating__close').click(function () {
        $(this).closest('.survey-floating').removeClass('active');
    });

    setTimeout(function () {
        $('.survey-floating').addClass('active');
    }, 3000);


    var accordion = (function(){

        var $accordion = $('.js-accordion');
        var $accordion_header = $accordion.find('.js-accordion-header');
        var $accordion_item = $('.js-accordion-item');

        // default settings
        var settings = {
            // animation speed
            speed: 400,

            // close all other accordion items if true
            oneOpen: false
        };

        return {
            // pass configurable object literal
            init: function($settings) {
                $accordion_header.on('click', function() {
                    accordion.toggle($(this));
                });

                $.extend(settings, $settings);

                // ensure only one accordion is active if oneOpen is true
                if(settings.oneOpen && $('.js-accordion-item.active').length > 1) {
                    $('.js-accordion-item.active:not(:first)').removeClass('active');
                }

                // reveal the active accordion bodies
                $('.js-accordion-item.active').find('> .js-accordion-body').show();
            },
            toggle: function($this) {

                if(settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-header')[0]) {
                    $this.closest('.js-accordion')
                        .find('> .js-accordion-item')
                        .removeClass('active')
                        .find('.js-accordion-body')
                        .slideUp();
                }

                // show/hide the clicked accordion item
                $this.closest('.js-accordion-item').toggleClass('active');
                $this.next().stop().slideToggle(settings.speed);
            }
        };
    })();

    $(".collapse-toggler").click(function (){
        $(this).toggleClass('expanded');
        $(this).next().toggleClass('expanded');
    });

    $(".description--hidden__trigger").click(function (){
        $(this).slideUp();
        $(this).next().slideDown();
    });

    if($('.innovation-slider').length){
        $('.innovation-slider').slick({
            slidesToShow: 1,
            autoplay: true,
        });
    }

    if($('.installation-slider').length){
        $('.installation-slider').slick({
            slidesToShow: 1,
            autoplay: true,
        });
    }

    if($('.inspired__slider').length){
        $('.inspired__slider').slick({
            centerMode: false,
            variableWidth: true,
            autoplay: true,
            prevArrow: $('.inspired-slider-navigation .slick-prev'),
            nextArrow: $('.inspired-slider-navigation .slick-next'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                    }
                },
            ]
        });
    }

    accordion.init({ speed: 300, oneOpen: true });
    AOS.init();

});

function toast(msg) {
    $('#snackbar').html(msg);
    $('#snackbar').addClass('show');

    setTimeout(function(){
        $('#snackbar').removeClass('show');
    }, 3000);
}
